/**
 * Fait : ouvre UNE connexion au canal temps réel pour une fiche de projet, et
 *   rend de quoi la fermer. Elle porte la présence ET les événements du
 *   projet — une seule prise pour les deux.
 *
 * Ne fait pas : elle n'affiche rien, ne décide d'aucun droit et ne recharge
 *   rien elle-même — elle prévient l'écran, qui décide.
 */

/**
 * Une seule connexion par écran : le plafond du serveur est de quatre par
 * compte, et deux navigateurs ouverts en consommeraient déjà la moitié.
 */
export function ecouteLeProjet(
  projetId: string,
  surPresence: (presents: string[]) => void,
  surEvenement: () => void,
  surFermeture: () => void,
): () => void {
  const adresse = `${location.origin.replace(/^http/, 'ws')}/api/canal`;
  const prise = new WebSocket(adresse);

  prise.addEventListener('open', () => {
    prise.send(
      JSON.stringify({ type: 'abonner_projet', emisLe: new Date().toISOString(), projetId }),
    );
  });

  prise.addEventListener('message', (evenement: MessageEvent<string>) => {
    const message = JSON.parse(evenement.data) as {
      type?: string;
      membresPresents?: string[];
    };

    if (message.type === 'presence') surPresence(message.membresPresents ?? []);
    if (message.type === 'evenement_projet') surEvenement();
  });

  // Le serveur peut fermer la prise — session finie, compte désactivé : on le
  // DIT à l'écran plutôt que de laisser une page qui a l'air vivante.
  //
  // Le drapeau `abandonnee` est indispensable : `onclose = null` n'enlève PAS
  // un écouteur posé par `addEventListener`, et le double montage de
  // `StrictMode` faisait alors crier « lien coupé » à CHAQUE ouverture de
  // fiche — l'alerte devenait indiscernable d'une vraie coupure (bloquant de
  // l'audit final de la phase 4).
  let abandonnee = false;

  prise.addEventListener('close', () => {
    if (!abandonnee) surFermeture();
  });

  return () => {
    abandonnee = true;
    prise.close();
  };
}
